import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-content flex-column pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, "You are all set to start using Reply200", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "connect-confirm-asset" }

import { facebookApi } from '@/api/facebook';
import { tiktokApi } from '@/api/tiktok';
import { useDataStore } from '@/stores/data';
import { useDialogStore } from '@/stores/dialogs';
import { reactive, ref } from 'vue';
import VAssetName from '../VAssetName.vue';
import VButton from '../VButton.vue';
import VSwitch from '../VSwitch.vue';
import FacebookConnectAlert from './FacebookConnectAlert.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectSocialConfirmDialog',
  props: {
    type: null,
    items: null,
    is_already_connected_businesses: { type: Boolean },
    already_connected_businesses: null
  },
  setup(__props: any) {

const props = __props as { type: string, items: any[], is_already_connected_businesses: boolean, already_connected_businesses: any[] }



const dataStore = useDataStore()

const values = reactive<number[]>(props.items.map(item => item.id))
const dialogStore = useDialogStore()

const pending = ref(false)
const apply = async () => {
  pending.value = true
  try {
    const disabled = props.items.filter(bm => !values.includes(bm.id)).map(bm => ({ id: bm.id }))
    if (disabled.length > 0) {
      if (props.type === "facebook") {
        await facebookApi.bms_disable(disabled)
      }
      if (props.type === "tiktok") {
        await tiktokApi.advertiser_disable(disabled)
      }
    }
    dataStore.requestBusinesses()
    if (props.type === "facebook") {
      dialogStore.open(FacebookConnectAlert)
    } else {
      dialogStore.close()
    }
  } catch(e) {
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", null, [
      (props.type === 'facebook')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Your Facebook is now connected")
          ], 64))
        : (props.type === 'tiktok')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Your TikTok is now connected")
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (props.is_already_connected_businesses)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(" The following business accounts are already connected to a different profile:"),
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("b", null, _toDisplayString(props.already_connected_businesses.join(', ')), 1),
            _hoisted_6,
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (business) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(VAssetName, { item: business }, null, 8, ["item"]),
          _createVNode(VSwitch, {
            value: business.id,
            modelValue: values,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(values) ? (values).value = $event : null))
          }, null, 8, ["value", "modelValue"])
        ]))
      }), 256)),
      _createVNode(VButton, {
        big: "",
        class: "mt-3",
        disabled: pending.value,
        onClick: apply
      }, {
        default: _withCtx(() => [
          _createTextVNode("Next")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})